export default __webpack_public_path__ + "assets/f85a41e54c808a8aa6e3c9fa70ceef61.gif";